// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"aa14f057","173":"20d7681a","916":"f3abc766"}[chunkId] + ".css";
};